import { Button, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface LimitReachedButtonProps {
	current: number;
	max: number;
	// Passed already-French into the tooltip interpolation — e.g. "scènes",
	// "musiques", "playlists", "groupes".
	limitType: string;
	label?: string;
}

// A disabled-looking button that stays hoverable so the subscription-limit
// tooltip shows.
export default function LimitReachedButton({
	current,
	max,
	limitType,
	label,
}: LimitReachedButtonProps) {
	const { t } = useTranslation();

	return (
		<Tooltip
			label={t(
				"You have reached your subscription limit ({{current}}/{{max}} {{limitType}}). Upgrade your plan to add more items.",
				{ current, max, limitType }
			)}
			multiline
			w={280}
		>
			<Button
				data-disabled
				style={{ pointerEvents: "auto" }}
				onClick={(event) => event.preventDefault()}
			>
				{label ?? t("Limit reached")}
			</Button>
		</Tooltip>
	);
}
